import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class ArticleVariantsService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/logistic-service/article-variants`, params),
      requestOptions
    );
  }

  create(variant) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(variant),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/article-variants`,
      requestOptions
    );
  }

  edit(variant) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(variant),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/article-variants/${variant.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/article-variants/${id}`,
      requestOptions
    );
  }
}
